import styled from 'styled-components'

export const Td = styled.td<{ selected?: boolean; active?: boolean }>`
  padding: 5px 5px !important;
  background-color: ${({ selected }) =>
    selected ? '#ccc!important' : 'white!important'};
  ${({ active }) => active && 'background-color: #72A0C1!important'};
  > div {
    margin-bottom: 0px;
  }
  input {
    padding: 5px;
  }
`

export const Th = styled.td<{ selected?: boolean }>`
  background-color: ${({ selected }) =>
    selected ? '#ccc!important' : 'white!important'};
`
